import React from "react";
import { Route } from "react-router-dom";
import SchoolInfo from "../components/SchoolInfo";
import SchoolsPage from "../components/SchoolsPage";

// import reports from '../data/reports.json';
// import water from '../data/water.json';
// import asbestos from '../data/asbestos.json';

const Schools = ({
  match,
  data,
  reports,
  water,
  asbestos,
  asbestos2020,
  food
}) => {
  return (
    <div>
      <switch>
        <Route
          path={`${match.url}/:schoolId`}
          render={props => (
            <SchoolInfo
              data={data}
              reports={reports}
              water={water}
              asbestos={asbestos}
              asbestos2020={asbestos2020}
              food={food}
              {...props}
            />
          )}
        />
        <Route
          exact
          path={match.url}
          render={props => (
            <SchoolsPage
              data={data}
              reports={reports}
              water={water}
              asbestos={asbestos}
              asbestos2020={asbestos2020}
              food={food}
              {...props}
            />
          )}
        />
      </switch>
    </div>
  );
};

export default Schools;



// WEBPACK FOOTER //
// ./src/routes/Schools.js